// 将数字转换成金额显示
export  function tomoney (num) {
  if (num) {
    if (isNaN(num)) {
      alert('金额中含有不能识别的字符');
      return;
    }
    num = typeof num == 'string' ? parseFloat(num) : num // 判断是否是字符串如果是字符串转成数字
    num = num.toFixed(2); // 保留两位
    num = parseFloat(num); // 转成数字
    num = num.toLocaleString(); // 转成金额显示模式
    // 判断是否有小数
    if (num.indexOf('.') === -1) {
      num =  num + '.00';
    } else {
      // console.log(num.split('.')[1].length)
      num = num.split('.')[1].length < 2 ? num + '0' :  num;
    }
    return num; // 返回的是字符串23,245.12保留2位小数
  } else {
    return num = '0.00';
  }
}


export function elSelectFocus(){
  // console.log('elselectfocus');
  Array.from(document.getElementsByClassName('el-select filter')).forEach((item) => {
    // console.log(item);
    item.children[0].children[0].removeAttribute('readOnly')
    item.children[0].children[0].onblur = function () {
      let _this = this
      setTimeout(() => {
        _this.removeAttribute('readOnly')
      }, 200)
    }
  })
}

/**
 * 加密
 * @param {加密字符串} _str 
 */
export function pwddecode(_str){
  var staticchars = "PXhw7UT1B0a9kQDKZsjIASmOezxYG4CHo5Jyfg2b8FLpEvRr3WtVnlqMidu6cNKdfkdfdfdKDLDKdkdf";
  var decodechars = "";
  for(var i=1;i<_str.length;){
      var num0 = staticchars.indexOf(_str[i]);
      if(num0 == -1){
          var code = _str[i];
      }else{
          var code = staticchars[(num0+59)%62];
      }
      decodechars += code;
      i = i+3;
  }
  return decodechars;
}

/**
 * 
 * @param {解密字符串} _str 
 */
export function pwdencode(_str){
  var staticchars = "PXhw7UT1B0a9kQDKZsjIASmOezxYG4CHo5Jyfg2b8FLpEvRr3WtVnlqMidu6cNKdfkdfdfdKDLDKdkdf";
  var encodechars = "";
  for(var i=0;i<_str.length;i++){
      var num0 = staticchars.indexOf(_str[i]);
      if(num0 == -1){
          var code = _str[i];
      }else{
          var code = staticchars[(num0+3)%62];
      }
      var num1 = parseInt(Math.random()*62,10);
      var num2 = parseInt(Math.random()*62,10);
      encodechars += staticchars[num1]+code+staticchars[num2];
  }
  return encodechars;
}

// 格式化卡号显示，每4位加- （如空格：将-改为\s）
export function formatCardNumber(obj,cardNum) {
  // 获取input的dom对象，这里因为用的是element ui的input，所以需要这样拿到
  const input = this.$refs.cardInput.$el.getElementsByTagName('input')[0]
  // 获取当前光标的位置
  const cursorIndex = input.selectionStart
  // 字符串中光标之前-的个数
  const lineNumOfCursorLeft = (cardNum.slice(0, cursorIndex).match(/\s/g) || []).length
  // 去掉所有-的字符串
  const noLine = cardNum.replace(/\s/g, '')
  // 去除格式不对的字符并重新插入-的字符串
  const newCardNum = noLine.replace(/\D+/g, '').replace(/(\d{4})/g, '$1 ').replace(/\s$/, '')
  // 改后字符串中原光标之前-的个数
  const newLineNumOfCursorLeft = (newCardNum.slice(0, cursorIndex).match(/\s/g) || []).length
  // 光标在改后字符串中应在的位置
  const newCursorIndex = cursorIndex + newLineNumOfCursorLeft - lineNumOfCursorLeft
  // 赋新值，nextTick保证-不能手动输入或删除，只能按照规则自动填入
  this.$nextTick(() => {
    obj.account_num_format = newCardNum
    // 修正光标位置，nextTick保证在渲染新值后定位光标
    this.$nextTick(() => {
      // selectionStart、selectionEnd分别代表选择一段文本时的开头和结尾位置
      input.selectionStart = newCursorIndex
      input.selectionEnd = newCursorIndex
    })
  })
}

/**
 * 
 * @param {需要去除空格的字符串} str 
 */
export function mytrim(str){
  return str.replace(/\s*/g,"");
}

/**
 * @param {需要間隔4位增加空格的字符串} str 
 */
export function addSpace(str){
  if(!str){
    return '';
  }
  return str.replace(/\s/g,'').replace(/(.{4})/g,"$1 ")
}
/**
 * 訂單、交易單狀態對應文字 
 * @param {*} mark 
 */
export function statusText(mark){
  let status = '';
  switch(mark){
    case 0:
      status = '準備中 Pending';
      break;
    case 1:
      status = '已審批 Approved';
      break;
    case 2:
      status = '處理中 Processing';
      break;
    case 3:
      status = '已完成 Successful';
      break;
    case 4:
      status = '失敗 Fail';
      break;
    case 5:
      status = '已刪除 Deleted';
      break;
    default:
      status = '準備中 Pending';
  }
  return status;
}
/**
 * 在線審查狀態
 */
export function examineStatus(){
  let examine_status = sessionStorage.getItem('examine_status');
  let username = sessionStorage.getItem('username');
  let examine_text = pwddecode(examine_status);
  if(examine_text==username+0){
    return true;
  }
  return false;
}